import { AppConfig } from './app.config';
import { courier } from './services/courier.service';

const appConfig = new AppConfig();

export const GlobalConfigAPI = {
  globalConfig: {},
  globalConfigURL: appConfig.getGlobalConfigURL(),

  getConfig<T>(key: string) {
    const existingConfig: T = this.globalConfig[key];

    if (typeof existingConfig !== 'undefined') {
      return Promise.resolve(existingConfig);
    }

    return courier.get(
      this.globalConfigURL,
      {
        uiOptions: {
          showLoading: false,
          showSuccessMsg: false
        }
      }
    ).then((res) => {
      this.globalConfig = res.data;
      return this.globalConfig[key];
    });
  }
};
